{
"a":{"occurs":"daily","time":"6:0", "pattern":"a", "disabled": true},
"b":{"occurs":"daily","time":"18:0","pattern":"a"},
"c":{"occurs":"selectedDays","days":[0,1,2,3,4,5],"time":"6:30", "pattern":"b"},
"d":{"occurs":"selectedDays","days":[7],"time":"6:45", "pattern":"c"},
"e":{"occurs":"selectedDays","days":[6,7],"time":"7:0", "pattern":"b"}
}
